module.exports = __webpack_public_path__ + "img/hk_active@2x.5025a894.png";